export default __webpack_public_path__ + "static/media/bg_wisps.06bb6914.png";